module.exports = __webpack_public_path__ + "static/img/naassom-azevedo-Q_Sei-TqSlc-unsplash_thumb.39a94b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/naassom-azevedo-Q_Sei-TqSlc-unsplash_thumb.png
// module id = vq2t
// module chunks = 4